import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { SidebarNoteStore } from './SidebarNoteStore';

export * from './SidebarNoteStore';

export * from './types';

export const { Provider: SidebarNoteStoreProvider, useStore: useSidebarNoteStore } =
  createContextLocalStore(SidebarNoteStore);
